import React, { useEffect, useState } from "react";

import ArrowDown from "../assets/icons/ArrowDown";
import Rightarrow from "../assets/icons/Rightarrow";
import { ToastContainer, toast } from "react-toastify";
import Loader from "./Loader";
import AddressDropdown from "./AddressDropdown";
import AddAddressModal from "./AddAddressModal";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Modal from "./Modal"; // Import your Modal component
import { useCart } from "../context/CartContect";
import { usePlaceOrder } from "../context/OrderContext";
import PaymentForm from "./PaymentModal";
import { post } from "../network/api";
import { useNavigate } from "react-router-dom";
import { calculateDeliveryCost } from "../utils/deliveryCost";
import { useTranslation } from "react-i18next";

const OrderSummary = () => {
  const { t } = useTranslation();
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("7973268843");
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const { cart } = useCart();
  const { order, setWalletAmount, setPaymentType, applyCoupon } = usePlaceOrder();
  const [walletBalance, setWalletBalance] = useState(0);
  const [description, setDescription] = useState("");
  const handleChange = (event) => {
    setDescription(event.target.value);
  };
  const subtotal = cart?.reduce((total, item) => total + item.quantity * item.product.price, 0);
  const [option, setOption] = useState("");
  const navigate = useNavigate();
    const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const isHidden = (hours >= 0 && hours < 9);
  

  const phoneValidationSchema = Yup.object({
    phoneNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),
  });

  async function handleApplyCoupon() {
    
    toast.loading("Please wait", {
      position: "bottom-center",
      autoClose: 3000,
    });

    if (couponCode.trim()) {
      try {
        
        const data = await post("customer/discounts/validate-coupon", {
          code: couponCode,
          subtotal: subtotal,
          deliveryCost: order.deliveryCost,
          totalAmount: order.totalAmount,
          restaurantId: order.restaurant._id,
        });
        toast.dismiss();
        setAppliedCoupon(data);
        applyCoupon(couponCode, data.coupon.coupon_type != 'cashback'?data.coupon.discount_value:0,data.coupon.coupon_type == 'cashback'? data.coupon.cashback_value:0);
        
        console.log("Coupon data is ", data);
           toast.success("Coupon applied successfully!", {
        position: "bottom-center",
        autoClose: 3000,
      });
      } catch (e) {
        toast.dismiss();
        console.log("Error applying coupon", e);
        toast.error(e.message, {
        position: "bottom-center",
        autoClose: 3000,
      });
      }

   
    } else {
      toast.error("Please enter a coupon code", {
        position: "bottom-center",
        autoClose: 3000,
      });
    }
  }

  async function placeOrder() {
    try {
      if (phoneNumber == null || phoneNumber.length < 10) {
        setIsLoading(false);
        toast.error("Please enter a valid phone number", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        return;
      }

      if (selectedAddress == null && option === "delivery") {
        setIsLoading(false);
        toast.error("Please select a address", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        return;
      }
      if (cart == null || cart.length == 0) {
        setIsLoading(false);
        toast.error("Please select atleast one item", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        return;
      }
      if (order.totalAmountToChargeFromCard <= 0) {
        handlePlaceOrder();
      } else {
        setShowPaymentModal(true);
      }
    } catch (e) {
      setIsLoading(false);
    }
  }
  const handlePlaceOrder = async (data) => {
    setShowPaymentModal(false);
    console.log(data);
    try {
      await post("customer/create-order", {
        items: cart,
        totalAmount: order.totalAmount,
        subTotal: subtotal,
        discountOnSubtotal: 0,
        discountOnDelivery: 0,
        cashbackValue: 0,
        isCashback: appliedCoupon?.coupon?.type === "cashback",  
        addressId: selectedAddress?._id,
        coupon: appliedCoupon?.coupon?._id || null,
        notes: description,
        deliveryType: option,
        restaurantId: order.restaurant._id,
        notesForCourier: "",
        payment: {
          method: order.method || "stripe",
          fromWallet: order.amountFromWallet,
          fromStripe: 0,
          stripe_data: data,
        },
      });
      // send it on orders page
      navigate("/account/orders");
    } catch (e) {}
    setIsLoading(false);
    // setTimeout(() => {
    //   setIsLoading(false);

    // }, 3000);
  };
  async function handlePaymentError(data) {
    console.log(data, "Payment Error");
    // handleClosePaymentModal(false)
  }
  async function handlePaymentSuccess(data) {
    console.log(data);
    handlePlaceOrder(data);
  }
  const handleAddAddress = (newAddress) => {
    // calculate deliveryCost

    console.log("Address is,", newAddress);
    setSelectedAddress(newAddress);
  };
  //

  async function getWalletBalance() {
    try {
      // setLoading(true)
      const data = await post("customer/wallet-balance");
      console.log("Wallet Balance is ", data);
      setWalletBalance(data.toFixed(2));
      // setLoading(false)
    } catch (error) {
      // setLoading(false);
    }
  }
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    setIsLoading(false);
  };

  useEffect(() => {
    getWalletBalance();
  }, []);

  return (
    <div className="order-summary">
      {/* Delivery Info */}
      {/* <div className="delivery-info">
        <span role="img" aria-label="delivery-time">
          ⏳
        </span>{" "}
        Your order delivered in 25mins
      </div> */}

      {/* ask for pickup or delivery  */}

      <div>
        <div className="delivery-item">
          <strong>{t("choose_delivery_option")}</strong>
        </div>

        <div className="flex flex-row gap-2 mb-2">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="orderType"
              value="pickup"
              checked={option === "pickup"}
              onChange={() => setOption("pickup")}
              className="w-4 h-4"
            />
            {t("pickup")}
          </label>
                {!isHidden && (
                  <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="orderType"
              value="delivery"
              checked={option === "delivery"}
              onChange={() => setOption("delivery")}
              className="w-4 h-4"
            />
            {t("delivery")}
          </label>
                )}
          
        </div>
      </div>

      {/* Summary Details */}

      <div className="summary-details">
        {option === "delivery" && (
          <AddressDropdown
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
            onAddAddress={handleOpenModal}
          />
        )}

        {/* Phone Number Section */}
        <div className="summary-item">
          <div className="flex-item">
            <strong>{t('phone_number')}: </strong>
            {isEditingPhone ? (
              <Formik
                initialValues={{ phoneNumber }}
                validationSchema={phoneValidationSchema}
                onSubmit={(values) => {
                  setPhoneNumber(values.phoneNumber);
                  setIsEditingPhone(false);
                }}>
                {({ touched, errors }) => (
                  <Form className="phone-edit form_group">
                    <Field
                      type="number"
                      name="phoneNumber"
                      // placeholder="Enter phone number"
                      className={`input-phone ${
                        touched.phoneNumber && errors.phoneNumber ? "error" : ""
                      }`}
                    />
                    {/* <ErrorMessage
                      name="phoneNumber"
                      component="div"
                      className="error"
                    /> */}
                  </Form>
                )}
              </Formik>
            ) : (
              <p
                onClick={() => setIsEditingPhone(true)}
                className="phone-number">
                {phoneNumber}
              </p>
            )}
          </div>
          <span className="arrow">
            <ArrowDown />
          </span>
        </div>

        {/* Coupon Section */}
        <div className="form_group coupon-section summary-item">
          <input
            type="text"
            placeholder={t('enter_coupon_code')}
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
            className="coupon-input"
          />
          <button onClick={handleApplyCoupon} className="btn btn-primary">
            {t('apply')}
          </button>
        </div>

        {/* Delivery Section */}
        <div className="summary-item">
          <span>{t('delivery_charge')}:</span>
          <span>€ {order.deliveryCost}</span>
        </div>
         {/* <div>
          {order.deal}
          </div>    */}
        {(order.deal!=null || order.deal!=undefined) &&(    
         <div className="discount-item">
          <span>{order.deal.deal_name} Discount ({order.deal.deal_value}%) :</span>
          <span>€{order.deal.deal_value}%</span>
        </div>
        )}

        {/* Delivery Section */}

        {appliedCoupon != null ? (
  <div className="discount-item" >
    <span>Discount Value:</span>
    <span>€{appliedCoupon?.coupon?.discount_value}</span>
  </div>
) : null}

            
        {/* Order Summary */}
        <div className="summary-item">
          <span>{t('total')}:</span>
          <span>€{order.totalAmount}</span>
        </div>
      </div>

      {/* Wallet Section */}
      <div className="wallet-section summary-item">
        <label className="wallet-label">
          <input
            type="checkbox"
            className="wallet-checkbox"
            onChange={(e) => {
              if (e.target.checked) {
                if (walletBalance < order.totalAmount) {
                  setWalletAmount(walletBalance);
                  setPaymentType("wallet+stripe");
                } else {
                  setWalletAmount(order.totalAmount);
                  setPaymentType("wallet");
                }

                toast.success("Wallet balance applied!", {
                  position: "bottom-center",
                  autoClose: 3000,
                });
              } else {
                setWalletAmount(0);
                setPaymentType("stripe");
              }
            }}
          />
          {t("use_wallet_balance")}: €{walletBalance}
        </label>
      </div>

      <div>
        <div class="form_group coupon-section summary-item">
          <input
            type="text"
            id="description"
            value={description}
            onChange={handleChange}
            placeholder={t("type_your_description_here")}
          />
        </div>
      </div>

      {/* Place Order Button */}

      <div className="rest_price_flex">
        <button
          className="btn btn-secondary"
          // onClick={() => handlePlaceOrder('data')}
          onClick={() => placeOrder()}
          // handlePlaceOrder
        >
          {t("place_order")} <Rightarrow />
        </button>
      </div>

      {/* Add Address Modal */}
      <AddAddressModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onAddAddress={handleAddAddress}
      />

      {/* Payment Modal */}
      <Modal show={showPaymentModal} onClose={handleClosePaymentModal}>
        <PaymentForm
          price={order.totalAmountToChargeFromCard}
          handleErrorCallback={handlePaymentError}
          handleSuccessCallback={handlePaymentSuccess}></PaymentForm>
      </Modal>

      {/* Show loader when isLoading is true */}
      {isLoading && <Loader />}

      <ToastContainer />
    </div>
  );
};

export default OrderSummary;
